import Compose from './Compose';

export default Compose;


// WEBPACK FOOTER //
// /src/components/mailThread/compose/index.js